import React, { useState, useRef, useEffect } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FaSmile } from "react-icons/fa";

const HomeTestimonials = () => {
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [expandable, setExpandable] = useState([]);

    const testimonials = [
        { text: "Very good teaching and give smart learning techinic. I would like to sincere thanks to the Whole team. Continue the sincerity", name: "Amanta Eldose" },
        { text: "Very fast and trustworthy service, really glad that took service from Athena coaching centre. They responds immediately and respond very fast.. really thankful to athena...", name: "Neethu E B" },
        { text: "I am glad to express my sincere thanks to athena coaching centre team who helped me to attain good score in my HAAD exam.", name: "Pooja Raju" },
        { text: "Very good institution and providing materials to read  and very support  during classes ,i thank u for your support to clear my exam .", name: "Preeny Pauly" },
        { text: "They helped me to complete my Saudi prometric exam. Thanks to athena", name: "Athullya" }
    ];

    const textRefs = useRef([]);

    useEffect(() => {
        setTimeout(() => {
            const results = textRefs.current.map(ref => {
                return ref && ref.scrollHeight > ref.clientHeight;
            });
            setExpandable(results);
        }, 100); // Small delay to ensure refs are populated
    }, []); // Runs only on mount

    const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    const responsive = {
        superLargeDesktop: { breakpoint: { max: 2400, min: 1800 }, items: 5 },
        desktop: { breakpoint: { max: 1800, min: 1024 }, items: 4 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
    };

    return (
        <div className="homeTestimonials">
            <div className="container">
                <div className="homeTestimonialsTitle">
                    <h2 className='title'>Student Success Stories & Reviews</h2>
                    <p>Proven results through student success stories.</p>
                </div>
            </div>
            <div className="homeTestimonialsMain">
                <Carousel responsive={responsive}>
                    {testimonials.map((item, index) => (
                        <div key={index} className={`homeTestimonialsBox ${expandedIndex === index ? 'expanded' : ''}`}>
                            <div className="smile">
                                <FaSmile /><FaSmile /><FaSmile /><FaSmile /><FaSmile />
                            </div>
                            <h4 
                                ref={(el) => (textRefs.current[index] = el)}
                                className={expandedIndex === index ? "expandedText" : "collapsedText"}
                            >
                                {item.text}
                            </h4>
                            {expandable[index] && (
                                <button className="toggleButton" onClick={() => toggleExpand(index)}>
                                    {expandedIndex === index ? "Shrink" : "Expand"}
                                </button>
                            )}
                            <h3>{item.name}</h3>
                        </div>
                    ))}
                </Carousel>
            </div>
        </div>
    );
};

export default HomeTestimonials;
